// 脏音
<template>

  <div>
    <div class="item-hd">
      <div>
        {{ $t('viewBase.a90') }}：
        <div class="tag" @click="showStartDate=true">
          {{ first ? dateFormat(start, 'YYYY/MM/DD') : $t('viewBase.a50') }}
        </div>
        -
        <div class="tag" @click="showEndDate=true">
          {{ first ? dateFormat(end, 'YYYY/MM/DD') : $t('viewBase.a51') }}
        </div>
      </div>
      <!-- <van-icon name="plus" class="addData" @click="handlePopup" /> -->
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="tips"
      @load="getList"
    >
      <div v-for="(item,index) in list" :key="index" class="data">
        <div class="hd">
          {{ dateFormat(item.testTime, 'MM-DD hh:mm') }}
        </div>

        <div class="bd sy-cell_flexEnd">
          <van-slider v-if="item.palyer" v-model="item.durationVal" class="audio-slider" active-color="#FCA251" disabled />
          <!-- <van-progress v-if="item.duration>0" :show-pivot="disshowPivot" :percentage="item.durationShow" class="audio-slider" /> -->
          <div>
            <!-- <audio ref="audios" :src="item.audioUrl" /> -->
            <van-icon v-show="!item.palyer" name="play-circle-o" @click="playAudio(item.audioUrl,item.id)" />
            <van-icon v-show="item.palyer" name="pause-circle-o" @click="suspendAudio" />
          </div>
        </div>
      </div>
    </van-list>
    <!-- start -->
    <van-datetime-picker
      v-show="showStartDate"
      v-model="start"
      type="date"
      :max-date="end"
      cancel-button-text=" "
      @confirm="handleDateConfirm('start')"
    />
    <!-- end -->
    <van-datetime-picker
      v-show="showEndDate"
      v-model="end"
      type="date"
      :max-date="maxDate"
      cancel-button-text=" "
      @confirm="handleDateConfirm('end')"
    />
  </div>
</template>

<script>
import { dateFormat, dateISO } from '@/utils/tool'
import { fetchStetho } from '@/api/health'

export default {
  data() {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    return {
      first: false,
      disshowPivot: false,
      timer: null,
      audios: null,
      showMeasureDate: false,
      datetime: new Date(),
      showPopup: false,
      dateFormat,
      showStartDate: false,
      showEndDate: false,
      start: date,
      end: new Date(),
      maxDate: new Date(),
      showDate: false,
      date: new Date(),
      currentDate: new Date(),
      tips: '',
      loading: false,
      finished: false,
      list: [],
      listQuery: {
        sTime: dateISO(`${dateFormat(date, 'YYYY/MM/DD')} 00:00:01`),
        eTime: dateISO(`${dateFormat(new Date(), 'YYYY/MM/DD')} 23:59:59`),
        page: 1,
        row: 20
      },
      dataForm: {
        deviceCode: 'string',
        state: 'string',
        measureDate: new Date()
      }
    }
  },
  created() {
    this.audios = new Audio()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    getList(date) {
      if (this.start) {
        this.listQuery.sTime = dateISO(`${dateFormat(this.start, 'YYYY/MM/DD')} 00:00:01`)
      }
      if (this.end) {
        this.listQuery.eTime = dateISO(`${dateFormat(this.end, 'YYYY/MM/DD')} 23:59:59`)
      }
      fetchStetho(this.listQuery).then(res => {
        this.loading = false
        const list = res.data.data
        res.data.data.forEach(item => {
          item.palyer = false
          item.duration = 0
          item.durationVal = 0
        })
        if (this.listQuery.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        this.listQuery.page++
        this.finished = list.length < 20
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
      })
    },
    handleDateConfirm(e) {
      this.first = true
      this.showStartDate = false
      this.showEndDate = false
      this.listQuery.page = 1
      this.getList()
    },

    handleMeasureDateConfirm() {
      this.showMeasureDate = false
      this.datetime = this.currentDate
    },
    handleMeasureDateCancel() {
      this.showMeasureDate = false
      this.dataForm.measureDate = this.datetime
    },
    handlePopup() {
      this.showPopup = true
    },
    playAudio(item, index) {
      this.list.forEach(item => {
        item.durationVal = 0
        item.palyer = false
      })
      this.audios.src = item
      this.durationValChange(index)
    },
    suspendAudio() {
      this.audios.pause()
      clearInterval(this.timer)
      this.list.forEach(item => {
        item.palyer = false
      })
    },
    durationValChange(index) {
      clearInterval(this.timer)
      var playPromise = this.audios.play()
      playPromise.then(() => {
        this.list.forEach((item, itemIndex) => {
          if (item.id === index) {
            item.palyer = true
            item.duration = this.audios.duration
            item.durationVal = 0
            item.durationShow = 0
            this.$set(this.list[itemIndex], 'duration', item.duration)
            this.timer = setInterval(() => {
              item.durationVal = this.audios.currentTime / this.audios.duration * 100
              item.durationShow = 100 / item.duration * item.durationVal
              if (item.durationVal >= 99) {
                clearInterval(this.timer)
                item.palyer = false
                item.duration = 0
              }
              // this.$set(this.list[itemIndex], 'durationShow', item.durationVal)
            }, 1000)
          } else {
            item.palyer = false
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .item-hd {
    background: #fff;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .addData {
      font-size: 18px;
  }
  .tag {
    display: inline-block;
    color: #666;
    padding: 5px 10px;
    background: #f8f8f8;
    border-radius: 1px solid #ececec;
    border-radius: 15px;
  }
  .data {
      display: flex;
      justify-content: space-between;
      background: #fff;
      margin-top: 10px;
      padding: 12px 15px;
      .hd {
          color: #999;
      }
      .bd {
          color: #666;
          text-align: right;
      }
  }
  .van-picker {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    }
    .popup-title {
        text-align: center;
        padding: 10px;
        font-weight: bold;
    }
    .btn {
        width: 92%;
        margin: 30px 4% 20px;
    }
    audio{
      width:auto;
      height: 30px;
}
.audio-slider{
width:80px;
margin-right:30px;
/deep/.van-slider__button{
  width:10px;
  height: 10px;
}

}
</style>
